import Dashboard from '@/views/Dashboard'
import Login from '@/views/Login'

export default [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: { auth: true }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { auth: false, layout: 'auth' }
    }
]
